<template>
  <b-modal
    ref="modal"
    title="Rezerwacja"
    centered
  >
    <TimetableItem
      :item="item"
      :event="event"
    />
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <div>
          <span v-if="!canManage" />
          <span v-else-if="!event.reservation">
            <b-button
              variant="danger"
              :disabled="blockReservationForm.processing"
              @click="blockReservation(event.date_string, event.barber.id)"
            >
              <b-icon icon="lock-fill" />
              Zablokuj
            </b-button>
            <span v-if="!reservationIdToMove">
              <b-button variant="info" @click="phoneReservation">
                <b-icon icon="telephone-fill" />
                Rez. tel.
              </b-button>
            </span>
            <span v-else>
              <b-button
                variant="warning"
                :disabled="moveReservationForm.processing"
                @click="moveReservation"
              >
                <b-icon icon="check2-square" />
                Wybierz
              </b-button>
            </span>
          </span>
          <span v-else-if="event.reservation.is_blocked">
            <b-button
              variant="success"
              :disabled="unlockReservationForm.processing"
              @click="unlockReservation(event.reservation.id)"
            >
              <b-icon icon="unlock-fill" />
              Odblokuj
            </b-button>
          </span>
          <span v-else-if="event.reservation.is_paid || event.reservation.by_phone">
            <b-button
              v-if="user.can_delete_reservations && !reservationIdToMove"
              variant="danger"
              @click="deleteReservation"
            >
              <b-icon icon="x" />
              Usuń
            </b-button>
            <b-button
              v-if="user.can_edit_reservations && !reservationIdToMove"
              variant="warning"
              @click="moveReservation"
            >
              <b-icon icon="arrow-clockwise" />
              Zmień termin
            </b-button>
            <b-button
              v-if="reservationIdToMove && reservationIdToMove !== event.reservation.id"
              variant="warning"
              :disabled="moveReservationForm.processing"
              @click="moveReservation"
            >
              <b-icon icon="check2-square" />
              Wybierz
            </b-button>
          </span>
        </div>
        <div>
          <b-button variant="primary" @click="hide('forget')">
            OK
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import TimetableItem from './Item'

export default {
  components: {
    TimetableItem,
  },
  props: {
    item: Object,
    event: Object,
    reservationIdToMove: Number,
  },
  data() {
    return {
      blockReservationForm: this.$inertia.form({
        dateString: '',
        barberId: 0,
      }),
      unlockReservationForm: this.$inertia.form({}),
      moveReservationForm: this.$inertia.form({
        dateString: '',
        barberId: 0,
        targetIsEmpty: true,
      }),
    }
  },
  computed: {
    canManage() {
      const now = new Date
      const date = new Date(this.item.end_at)
      return date > now
    },
    user() {
      return this.$page.props.auth.user
    },
  },
  methods: {
    blockReservation(dateString, barberId) {
      this.blockReservationForm.dateString = dateString
      this.blockReservationForm.barberId = barberId

      this.blockReservationForm.post(this.route('reservations.block'), {
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => {
          this.hide()
        }
      })
    },
    unlockReservation(reservationId) {
      this.unlockReservationForm.post(this.route('reservations.unlock', reservationId), {
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => this.hide()
      })
    },
    phoneReservation() {
      this.hide()
      this.$emit('phoneReservation', this.item, this.event)
    },
    deleteReservation() {
      this.hide()
      this.$emit('deleteReservation', this.item, this.event)
    },
    moveReservation() {
      if (!this.reservationIdToMove) {
        if (!this.event.reservation) return;
        this.hide()
        this.$emit('reservationIdToMove', this.event.reservation.id)
      } else {
        this.moveReservationForm.dateString = this.event.date_string
        this.moveReservationForm.barberId = this.event.barber.id
        this.moveReservationForm.targetIsEmpty = !this.event.reservation

        this.moveReservationForm.post(this.route('reservations.move', this.reservationIdToMove), {
          preserveState: true,
          preserveScroll: true,
          onSuccess: () => {
            this.$emit('reservationIdToMove', 0)
            this.hide()
          }
        })
      }
    },
    resetForms() {
      this.blockReservationForm.reset()
      this.unlockReservationForm.reset()
      this.moveReservationForm.reset()
    },
    show() {
      this.resetForms()
      this.$refs.modal.show()
    },
    hide() {
      this.resetForms()
      this.$refs.modal.hide()
    },
  },
}
</script>
